import { TenantProvider } from "@/context/TenantContext";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "@/project/router";

const router = getRouter();

function App() {
  return (
    <TenantProvider>
      <RouterProvider router={router} />
    </TenantProvider>
  );
}

export default App;
